import React, { createContext } from 'react';
import { Entity } from '../useDocumentVault';

interface Context {
  setSelectedEntity(entity: Entity | null): boolean;
  selectedEntity: Entity | null;
  forceYear: number | null;
  setForceYear(year: number | null): void;
}

export const DocumentVaultContext = createContext<Context | undefined>(undefined);

interface Props {
  value: Context;
  children: React.ReactNode;
}

export const DocumentVaultProvider = ({ children, value }: Props) => (
  <DocumentVaultContext.Provider value={value}>{children}</DocumentVaultContext.Provider>
);
